import { render } from "./UserList.vue?vue&type=template&id=9718afc2&scoped=true"
import script from "./UserList.vue?vue&type=script&lang=js"
export * from "./UserList.vue?vue&type=script&lang=js"

import "./UserList.vue?vue&type=style&index=0&id=9718afc2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9718afc2"]])

export default __exports__